
import WidgetBase from '../widget.base';
import { pushTrackingData } from '../../lib/dataLayer';

export default class WifiFormComponent extends WidgetBase {
    static selector = '[data-js-wifi-form]';

    constructor(el) {
        super(el);
        const form = this.el.querySelector('form');
        if (typeof (form) === 'undefined') {
            return;
        }

        form.addEventListener('submit', () => {
            pushTrackingData({
                'name': 'submit_wifi'
            });
        });
        
        setTimeout(() => {
            this.loaded();
        });
    }
}